(() => {
  const singles = window.vadeSingleVariants || {};
  function imageGroup(group, src) {
    if (!group) return;
    const count = Number(group.dataset.count) === 10 ? 10 : 1;
    let first = group.querySelector('img');
    if (!first && src) {
      first = document.createElement('img');
      first.src = src;
      first.alt = '10 individual single-serving packs';
      group.append(first);
    }
    if (!first) return;
    if (src) first.src = src;
    group.querySelectorAll('[data-vade-image-copy]').forEach(i => i.remove());
    for (let i = 1; i < count; i++) {
      const copy = first.cloneNode();
      copy.removeAttribute('data-clearance-product-image');
      copy.removeAttribute('id');
      copy.alt = '';
      copy.dataset.vadeImageCopy = 'true';
      group.append(copy);
    }
  }
  function sync() {
    document.querySelectorAll('[data-clearance-image-group]').forEach(g => {
      if (g.dataset.vadeRendered !== g.dataset.count + g.querySelector('img')?.src) {
        imageGroup(g);
        g.dataset.vadeRendered = g.dataset.count + g.querySelector('img')?.src;
      }
    });
    document.querySelectorAll('product-info').forEach(info => {
      const id = info.querySelector('form[action*="/cart/add"] [name=id]')?.value;
      const single = singles[id];
      const q = info.querySelector('[name=quantity]');
      if (q) {
        if (q.tagName === 'SELECT' && q.dataset.vadeSingle !== String(Boolean(single))) {
          const start = single ? 10 : 1;
          q.replaceChildren(...Array.from({length:12}, (_, i) => new Option(String(start+i), String(start+i))));
        }
        if (single) {
          q.min = '10'; q.dataset.min = '10'; q.step = '1';
          if (q.dataset.vadeVariant !== id || Number(q.value) < 10) q.value = '10';
        } else if (q.dataset.vadeSingle === 'true') {
          q.min = '1'; q.dataset.min = '1'; q.value = '1';
        }
        q.dataset.vadeVariant = id || '';
        q.dataset.vadeSingle = single ? 'true' : 'false';
      }
      const detail = info.querySelector('[data-vade-product-singles]');
      if (detail) {
        detail.hidden = !single;
        const group = detail.querySelector('[data-vade-detail-images]');
        if (single && group?.dataset.vadeVariant !== id) {imageGroup(group, single.image); group.dataset.vadeVariant = id;}
      }
    });
    document.querySelectorAll('input[data-quantity-variant-id]').forEach(q => {
      if (singles[q.dataset.quantityVariantId]) {q.min = '10'; q.step = '1';}
    });
    document.querySelectorAll('variant-selects option,variant-selects label').forEach(label => {
      if (label.textContent.trim() === '1 Serving') {
        if (label.tagName === 'OPTION' && !label.hasAttribute('value')) label.value = '1 Serving';
        label.textContent = '10 Single Servings';
      }
    });
  }
  document.addEventListener('change', event => {
    const q = event.target;
    if (q.matches('input[data-quantity-variant-id]') && singles[q.dataset.quantityVariantId] && Number(q.value) < 10) {
      q.value = '10';
    }
    queueMicrotask(sync);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    const id = form.querySelector('[name=id]')?.value;
    if (!singles[id]) return;
    let q = form.elements.namedItem('quantity');
    if (!q) {q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; form.append(q);}
    q.value = String(Math.max(10, Number(q.value) || 10));
  }, true);
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {scheduled = false; sync();});
  }).observe(document.body, {childList:true,subtree:true});
  sync();
})();
